export default function loginPage() {
  const page = document.querySelector(".login-register");
  if (page) {
    const options = page.querySelectorAll(".js-login-options .js-option");
    if (options.length > 0) {
      options.forEach((item) => {
        item.addEventListener("click", () => {
          // Remove 'is-active' class from all targets
          options.forEach((btn) => {
            const targetElement = page.querySelector(btn.dataset.target);
            btn.classList.remove("is-active");
            if (targetElement) {
              targetElement.classList.remove("is-active");
            }
          });

          item.classList.add("is-active");
          const target = page.querySelector(item.dataset.target);
          if (target) {
            target.classList.add("is-active");
          }
        });
      });
    }
  }
}
